<template>
    <div class="vx-multi-search-bar">
        <div
            v-for="(search, index) in searchFields"
            :key="index"
            class="child"
            :class="{ 'child--featured': featured == index }"
            :style="`width: calc(100% /  ${searchFields.length} + 10%)`"
        >
            <vx-elastic-suggest
                :name="search.name"
                class="elastic-suggest"
                :value="$store.getters[search.storeGetter]"
                :search_groups="search.group"
                :placeholder="search.placeholder"
                remove-validation-padding
                :list-icon="search.icon"
                :show-on-focus="search.showOnFocus"
                @input="(v) => $store.commit(search.storeSetter, v)"
                @focus="featured = index"
                @blur="featured = -1"
            >
                <template
                    v-for="(group_name, index) in Object.keys(search.group)"
                    v-slot:[group_name]="{ suggestion }"
                >
                    <div v-if="$scopedSlots[group_name] || $slots[group_name]" :key="index">
                        <slot :name="group_name" :suggestion="suggestion"></slot>
                    </div>
                </template>
            </vx-elastic-suggest>
            <slot></slot>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'vx-multi-search-bar',
    props: {
        searchFields: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            featured: -1
        }
    },
    methods: {
        clearAll() {
            this.searchFields.forEach((sf) => {
                this.$store.commit(sf.storeSetter, null)
            })
        }
    }
}
</script>

<style scoped>
.elastic-suggest {
    transition: all 0.3s;
    font-size: 16.8px !important;
}
.elastic-suggest >>> input {
    background-color: transparent;
    border: none !important;
    border-radius: 0;
    padding: 1rem 0.8rem 1rem 3rem !important;
    font-size: 1.2rem !important;
}
.elastic-suggest >>> .input-span-placeholder {
    padding-left: 3rem !important;
    padding: 1rem !important;
    left: 0;
    top: 0px;
}
.elastic-suggest >>> i {
    left: 0.8rem !important;
    top: 1rem !important;
    border: 0;
    font-weight: 100;
}
.elastic-suggest >>> .vs-input > span {
    display: none;
}
.child {
    transition: all 0.3s ease;
}
.vx-multi-search-bar {
    /* background-color: #10163a !important; */
    position: relative;
    display: flex;
}
.child--featured {
    flex-shrink: 0;
}
</style>
